module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password"
  }, [(_vm.state == 'loading') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().loading.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().loading.text))])])]) : _vm._e(), _vm._v(" "), (_vm.state == 'used' || _vm.state == 'expired' || _vm.state == 'done' || _vm.state == 'notFound') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))])]), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'loging'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n()[_vm.state].loginButton) + "\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state == 'ready' || _vm.state == 'working') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand"
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [(_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.i18n().errors[_vm.error] || _vm.error))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('form', {
    class: {
      blurred: _vm.state == 'working'
    },
    on: {
      "submit": _vm.change
    }
  }, [_c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword1),
      expression: "newPassword1"
    }],
    ref: "newPassword1",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword1",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword1"
    }
  }, [_vm._v(_vm._s(_vm.i18n().newPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield mdl-js-textfield mdl-textfield--floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword2),
      expression: "newPassword2"
    }],
    ref: "newPassword2",
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "password",
      "id": "newPassword2",
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.newPassword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "newPassword2"
    }
  }, [_vm._v(_vm._s(_vm.i18n().retypePassword))]), _vm._v(" "), (_vm.notMatch) ? _c('span', {
    staticClass: "mdl-textfield__error"
  }, [_vm._v(_vm._s(_vm.i18n().notMatch))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n().submit) + "\n        ")])]), _vm._v(" "), (_vm.state == 'working') ? _c('div', {
    staticClass: "working"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8818292c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailPassword/ResetPassword.vue
// module id = 464
// module chunks = 0